import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { BuilderPage } from '@makyoapp/makyo-common'
import { Screen24 } from '@makyoapp/makyo-icon/icon'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { useAppPagesContext } from '@/context/AppPagesContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'
import { SHOW_SEARCH_LIMIT } from '@/shared/constants'

const RenderPageOption = ({ page }: { page: BuilderPage }) => {
  const pageTitle = useVariableTextSingleCell(page.title)
  return (
    <span className='flex items-center'>
      {page?.icon && <MaterialIcon size={20} icon={page.icon ?? 'info'} className='mr-2' />}
      <span className={clsx(!page.id && 'text-light')}>{pageTitle}</span>
    </span>
  )
}

interface PageDropdownProps {
  id?: string
  value?: string | string[]
  excludeCurrentPage?: boolean
  excludePages?: string[]
  multiple?: boolean
  onChange?: (nextValue: string | string[]) => void
  isLoginComponent?: boolean
}

export function ScreenDropdownV2({
  id,
  value,
  multiple = false,
  onChange,
  excludeCurrentPage = true,
  excludePages = [],
  isLoginComponent = false,
}: PageDropdownProps) {
  const { pages, activePageIndex } = useAppPagesContext()
  const activePageId = pages[activePageIndex].id

  const filteredPages = pages.filter((p) => {
    if (p.tableId) return false
    if (excludeCurrentPage && activePageId === p.id) {
      return false
    }
    return !excludePages.includes(p.id)
  })

  const pageOptions = isLoginComponent
    ? [
        { id: 'current-page', name: 'Stay in current page', icon: 'Login16' } as unknown as BuilderPage,
        ...filteredPages,
      ]
    : filteredPages

  return (
    <SelectDropdown
      withSearch={pages.length > SHOW_SEARCH_LIMIT}
      id={id}
      multiple={multiple}
      value={
        !multiple
          ? (pageOptions.find((p) => p.id === value) as BuilderPage)
          : (pageOptions.filter((p) => {
              const arrVal = !Array.isArray(value) ? [] : value
              return arrVal.includes(p.id)
            }) as unknown as BuilderPage)
      }
      onChange={(opt) => {
        onChange?.(multiple ? (opt as unknown as BuilderPage[]).map((p) => p.id) : opt.id)
      }}
      optionLabel={(opt) => `${opt?.title} ${opt?.id}`}
      renderOption={(opt) => {
        if (!opt) {
          return (
            <div className='flex-c text-light'>
              <Screen24 width={16} height={16} />
              <Trans>Select Screen</Trans>
            </div>
          )
        }
        if (opt.id === 'current-page') {
          return (
            <span className='flex items-center'>
              <MaterialIcon size={20} icon='refresh' className='mr-2' />
              <span>Stay in current page</span>
            </span>
          )
        }
        return <RenderPageOption page={opt} />
      }}
      options={pageOptions}
    />
  )
}
